import "./styles.css";
import React, { useState } from "react";
import { Box, Modal } from "@mui/material";
import PasswordForm from "./password-form";
import VerificationCode from "./verification-code";
import { FormattedMessage } from "react-intl";
import { BaseButton } from "../../base";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  maxWidth: "560px"
};

export default function ChangePassword() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [screen, setScreen] = useState("password");
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    code: ""
  });

  const handleClose = () => {
    setIsModalVisible(false);
    setScreen("password");
  };

  return (
    <Box>
      <Box>
        <BaseButton
          data-testid="change-password-button"
          variant="filled"
          size="lg"
          onClick={() => {
            setIsModalVisible(true);
          }}
          sx={{
            width: "174px",
            flexGrow: 0,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px"
            // Background/hover come from BaseButton's `filled` variant — no need
            // to re-pin the token here.
          }}
        >
          <FormattedMessage id="Change Password" />
        </BaseButton>
      </Box>
      <Modal
        open={isModalVisible}
        // onClose={handleClose}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "var(--overlay-future-tax-60)"
            }
          }
        }}
      >
        <Box sx={style}>
          {screen === "password" && (
            <PasswordForm
              setScreen={setScreen}
              setIsModalVisible={setIsModalVisible}
              setFinalData={setFormData}
              onClose={handleClose}
            />
          )}
          {screen === "code" && (
            <VerificationCode
              setScreen={setScreen}
              formData={formData}
              setIsModalVisible={setIsModalVisible}
              onClose={handleClose}
            />
          )}
        </Box>
      </Modal>
    </Box>
  );
}
